import { render, staticRenderFns } from "./KnAddress.vue?vue&type=template&id=45a06154&"
import script from "./KnAddress.vue?vue&type=script&lang=js&"
export * from "./KnAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports